import getPartialTaskFromTodo from '../utils/getPartialTaskFromTodo';
import getTodoRequestHeaders from './getTodoRequestHeaders';
import Todo from '../store/schema/Todo';
import { format } from 'owa-strings';
import { isSuccessStatusCode } from 'owa-http-status-codes';
import { makePostRequest } from 'owa-ows-gateway';
import { TODO_API_CREATE_TASK_IN_FOLDER_FORMAT, TODO_API_DEFAULT_FOLDER } from './constants';

/**
 * Calls createItem to create tasks
 */
export default function createTaskService(
    todo: Todo,
    parentFolderId: string = null
): Promise<boolean> {
    const folderIdToUse = parentFolderId ? parentFolderId : TODO_API_DEFAULT_FOLDER;
    const url = format(TODO_API_CREATE_TASK_IN_FOLDER_FORMAT, folderIdToUse);

    return makePostRequest(
        url,
        getPartialTaskFromTodo(todo, true /*ignoreNullValues*/),
        null /* correlationId */,
        true /* returnFullResponse */,
        getTodoRequestHeaders() /* customHeaders */
    )
        .then((response: Response) => {
            return isSuccessStatusCode(response.status);
        })
        .catch(err => {
            return false;
        });
}
